import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Action } from '@ngrx/store';

export enum USMoveQueueActionTypes {
  LOAD_USMOVEQUEUE = '[USMOVEQUEUE] Load USMoveQueue',
  LOAD_USMOVEQUEUE_SUCCESS = '[USMOVEQUEUE] Load USMoveQueue Success',
  LOAD_USMOVEQUEUE_FAIL = '[USMOVEQUEUE] Load USMoveQueue Fail',
}

export class LOADUSMOVEQUEUE implements Action {
  readonly type = USMoveQueueActionTypes.LOAD_USMOVEQUEUE;
  constructor(public payload: number, public queuetype: number, public workqueueStatusId: number, public accountUpdateOptionId: number, public customerFollowUpOptionId: number, public investigationOptionId: number, public insuranceFollowUpOptionId: number) { }
}

export class LOADUSMOVEQUEUESUCCESS implements Action {
  readonly type = USMoveQueueActionTypes.LOAD_USMOVEQUEUE_SUCCESS;
  constructor(public payload: WorkQueueDetails) { }
}

export class LOADUSMOVEQUEUEFAIL implements Action {
  readonly type = USMoveQueueActionTypes.LOAD_USMOVEQUEUE_FAIL;
  constructor(public payload: string) { }
}

export type USMoveQueueAction =
  | LOADUSMOVEQUEUE
  | LOADUSMOVEQUEUESUCCESS
  | LOADUSMOVEQUEUEFAIL;
